'use client';

import { supplierApi, type Supplier } from '@/app/(modules)/robot-manager/_lib/api';
import { Badge } from '@/app/(modules)/robot-manager/_lib/SimpleListPage';
import { CrudListPage } from '@/app/(modules)/robot-manager/_lib/CrudListPage';

import { countryToCurrency } from '@/lib/country-currency';

export default function SuppliersAdminPage() {
  return (
    <CrudListPage<Supplier>
      title="供应商"
      description="跨模块复用的供应商主数据"
      api={supplierApi}
      draftKey="platform-master:supplier"
      inlineEditFields={['enabled']}
      formFields={[
        {
          key: 'code',
          label: '编码',
          type: 'text',
          placeholder: '留空自动生成（S-时间戳）',
          createOnly: true,
          validate: (v) => (v && String(v).length < 3 ? '至少 3 位' : null),
        },
        { key: 'name', label: '名称', type: 'text', required: true },
        {
          key: 'type',
          label: '类型',
          type: 'select',
          required: true,
          defaultValue: 'MANUFACTURER',
          options: [
            { value: 'MANUFACTURER', label: '制造商' },
            { value: 'PARTS', label: '零部件' },
            { value: 'LOGISTICS', label: '物流' },
            { value: 'SERVICE', label: '服务' },
          ],
        },
        {
          key: 'countryCode',
          label: '国家代码',
          type: 'text',
          placeholder: 'ISO-2（如 CN）',
          validate: (v) =>
            v && !/^[A-Z]{2}$/.test(String(v).toUpperCase()) ? '应为 2 位字母' : null,
        },
        {
          key: 'currencyCode',
          label: '币种',
          type: 'text',
          placeholder: '从国家自动推断',
          derive: (all) => countryToCurrency(all.countryCode),
        },
        { key: 'paymentTerms', label: '付款条件', type: 'text', placeholder: '如 Net 30 / Net 45' },
        { key: 'leadTimeDays', label: '交期 (天)', type: 'number' },
        { key: 'enabled', label: '启用', type: 'boolean', defaultValue: true },
      ]}
      columns={[
        { key: 'code', label: '编码', width: '160px' },
        { key: 'name', label: '名称' },
        { key: 'type', label: '类型', width: '120px', render: (s) => <Badge text={s.type} /> },
        { key: 'countryCode', label: '国家', width: '80px' },
        { key: 'currencyCode', label: '币种', width: '80px' },
        { key: 'leadTimeDays', label: '交期(天)', width: '90px' },
        { key: 'paymentTerms', label: '付款条件' },
        { key: 'enabled', label: '启用', width: '80px', render: (s) => (s.enabled ? '✓' : '✗') },
      ]}
    />
  );
}
